import { put, call, take, fork } from 'redux-saga/effects'
import { LLMDeleteAttachmentService } from '../../api/llm'
import { llmDeleteAttachmentSuccess } from '../../reducers/llm/action'
import { DELETE_CHAT_ATTACHMENT } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* deleteAttachmentFlow(payload) {
  try {
    const { chatId, attachmentId, callback } = payload

    const response = yield call(
      LLMDeleteAttachmentService,
      chatId,
      attachmentId,
    )

    yield put(llmDeleteAttachmentSuccess(attachmentId))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* deleteAttachmentWatcher() {
  while (true) {
    const action = yield take(DELETE_CHAT_ATTACHMENT)
    const { payload } = action

    yield fork(generalSaga, deleteAttachmentFlow, payload, false)
  }
}
